export default "__VITE_ASSET__ZgEjf40V__"